import React, { FC, PropsWithChildren } from 'react'

import { cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { WithClassName } from 'common/types'

export const Slot: FC<
  PropsWithChildren &
    WithClassName & {
      type: 'vertical' | 'horizontal'
      tag?: 'div' | 'li' | 'p'
    }
> = ({ children, className, type, tag }) => {
  switch (type) {
    case 'vertical':
      return (
        <Parent className={cx(className)} as={tag}>
          {children}
        </Parent>
      )

    /** Пока нет горизонтальных примеров в дизайне  */
    case 'horizontal':
    default:
      return null
  }
}

const Parent = styled.div`
  padding: var(--spacing-4px) 20px;
`
